import React from 'react'
import {Badge} from "@mantine/core";

const types = ["Demandeur d'asile","Réfugié protégé","Résident permanent","Citoyen","Travailleur temporaire","Étudiant étranger","Visa visiteur"]

export default function MemberBadge({type,idMembre}) {
  switch (type){
  case "Citoyen" : return <Badge color='blue' variant='outline'>{ "Citoyen"}</Badge> 
  case "Demandeur d'asile": return <Badge color='teal' variant='outline'>Demandeur d'asile</Badge> 
  case "Réfugié protégé": return  <Badge color='green' variant='outline'>{"Réfugié protégé"}</Badge>
  case "Résident permanent": return  <Badge color='orange' variant='outline'>{"Résident permanent"}</Badge>
  case "Travailleur temporaire": return  <Badge color='grape' variant='outline'>{"Travailleur temporaire"}</Badge>
  case "Étudiant étranger": return  <Badge color='indigo' variant='outline'>{"Étudiant étranger"}</Badge>
  case "Visa visiteur": return  <Badge color='violet' variant='outline'>{"Visa visiteur"}</Badge>
  case "Autres": return <Badge color='red' variant='outline'>Autres</Badge>
  default: return <Badge color='red' variant='outline'>ERREUR</Badge>
  }
}
